import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import { Table } from "antd";
import { all_routes } from "../../../router/all_routes";
import { getCourseDepartments } from "../../../../core/data/redux/masterCourseDepartmentsSlice";

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface CourseDepartmentList {
    id: number;
    category_id?: string;
    department?: string;
    course?: string;
    course_fee?: string;
    contributor?: string;
}





const CourseDepartment = () => {

    const dispatch = useDispatch<AppDispatch>();
    const masterCourseDepartmentsState = useSelector((state: any) => state.masterCourseDepartmentsState);
    const [dataList, setDataList] = useState<CourseDepartmentList[]>([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    const routes = all_routes;
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            key: "srNo",
            render: (_text: any, _record: any, index: number) =>
                (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: "Category ID",
            dataIndex: "category_id",
            key: "category_id",
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
        },
        {
            title: "Course",
            dataIndex: "course",
            key: "course",
        },
        {
            title: "Course Fee",
            dataIndex: "course_fee",
            key: "course_fee",
        },
        {
            title: "Contributor",
            dataIndex: "contributor",
            key: "contributor",
        }
    ];

    React.useEffect(() => {
        dispatch(getCourseDepartments({}));
    }, []);

    React.useEffect(() => {
        setDataList(masterCourseDepartmentsState?.data?.data || [])
    }, [masterCourseDepartmentsState.loading]);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <h3 className="page-title mb-1">Course Department List</h3>
                    <nav>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <Link to={routes.adminDashboard}>Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">Course Department</li>
                        </ol>
                    </nav>
                </div>

                <div className="card">
                    <div className="card-body">
                        <Table
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: dataList.length,
                                showSizeChanger: false,
                                onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
                            }}
                            columns={columns}
                            dataSource={dataList}
                            loading={masterCourseDepartmentsState?.isLoading || false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseDepartment;
